module.exports = __webpack_public_path__ + "assets/img/top.c14c15ea.png";